import { Component, OnInit, ElementRef, Renderer, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common'
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ConfirmPaymentService } from '../services/confirm_payment.service';
import { Cookie } from '../shared/cookie.service';

import { AppSettings } from '../settings/app.settings';
import { CurrencyService } from '../shared/currency.service';
import { HeaderService } from '../shared/header.service';
import { AnalyticsUtilsService } from '../shared/analytics-utils.service';
import { HttpCssClient } from '../shared/http-request.interceptor';


declare var saveAs:any;
declare var AFProcessSaleV2:any;

@Component({
  selector: 'confirm_payment',
  styleUrls: [ './confirm_payment.component.scss' ],
  templateUrl: './confirm_payment.component.html',
  encapsulation: ViewEncapsulation.Emulated
})
export class ConfirmPaymentComponent{
  public isNode:boolean;
  public item:Object={sales:[]};
  public total:number = 0; 
  public currencyStr:string = "EUR";
  public pending:boolean = false;
  public quitDisplay:boolean = true;
  public isMobileVoucher:boolean = false;
  public isPaperRequired:boolean = false;
  public oldToken:string;
  
  constructor(private confirmPaymentSercive:ConfirmPaymentService, private http:HttpCssClient, private translate:TranslateService, 
  private cookie:Cookie, private router:Router, public currencyService:CurrencyService, private headerService:HeaderService,
  private element:ElementRef, private renderer:Renderer, private analyticsUtils:AnalyticsUtilsService, @Inject(PLATFORM_ID) private platformId:Object) {
      this.isNode = isPlatformServer(this.platformId);
      if(!this.isNode){
        this.oldToken = this.cookie.get()[("guest_session")];
        this.getPaymentResume();
        this.cookie.remove("guest_cart_element");
        this.http.addHeader("Authorization",this.cookie.get()['guest_session']);
        this.cookie.remove('guest_session');
        this.headerService.numElementsCart = 0;
        this.removeDisplay();
      }
  }

  redirectToHome(){
    this.analyticsUtils.click_on_continue();
    this.router.navigateByUrl('/');
  }

  getPaymentResume(){
    if(this.cookie.get()['process_data_pending'] == "pending payment"){
      this.pending = true;
      this.cookie.remove('process_data_pending');
    }
    this.cookie.remove('process_data');
    return this.confirmPaymentSercive.getPaymentResume().subscribe(item=>{
      if(item['response'] != null) {
        this.quitDisplay = false;
        this.item = item['response'];
        let token = item['token'];
        this.cookie.put("guest_session",token);
        this.currencyStr = AppSettings.currencies[this.item['payment']['idCurrency']];
        let sales:Object[] = this.item['sales'];
        if(sales != null){
          sales.forEach(sale=>{
              if(sale['productMainImage']!= null){
                sale['productMainImage'] = AppSettings.CSS_CE_IMAGES + sale['productMainImage'];
              }
              if(sale['mobileAccess']){
                this.isMobileVoucher = true;
              } else {
                this.isPaperRequired = true;
              }
            }
          );
        }
        // this.checkSource();
        this.analyticsUtils.eCommerce_purchase(this.item, this.currencyService.currencyStr);
        } else {
          if(!this.pending){
            this.router.navigateByUrl('/');
          }
        }
      },
      error => {
        this.router.navigateByUrl('/');
    });
  }

  removeDisplay() {
    setTimeout(() => {
      this.quitDisplay = true;
    }, 6000);
  }

  removeDisplayClick(){
    this.quitDisplay = true;
  }
}